var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1465 0.146475L12.4434 1.43554C12.6387 1.63085 12.6387 1.95116 12.4434 2.14648L6.64649 7.93555C6.45118 8.13086 6.13868 8.13086 5.94337 7.93555L0.146485 2.14648C-0.0488282 1.95116 -0.0488282 1.63085 0.146485 1.43554L1.44336 0.146475C1.63867 -0.0488377 1.95117 -0.0488377 2.14649 0.146475L6.29493 4.29492L10.4434 0.146475C10.6387 -0.0488377 10.9512 -0.0488377 11.1465 0.146475Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/Arrow-down.140e6d6f2725d9dc97827f3414c63f11.svg";
export { ForwardRef as ReactComponent };